import React from 'react';
import { Card, Typography, Skeleton } from 'antd';
import { useI18n, getLocale } from '../i18n';

const { Text, Title } = Typography;

const StatWidget = ({ labelKey, value = 0, unitType = 'people', accent = '#1677ff', isLoading = false, onClick, disabled = false }) => {
  const { lang, t } = useI18n();
  const locale = getLocale(lang);

  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: unitType === 'usd' ? 2 : 0,
    maximumFractionDigits: unitType === 'usd' ? 2 : 0
  }).format(value || 0);

  const unit = unitType === 'people' ? t('peopleUnit') : unitType === 'usd' ? t('usdUnit') : '';
  const isInteractive = !!onClick && !disabled && !isLoading;

  return (
    <Card
      hoverable={isInteractive}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-disabled={!isInteractive}
      onClick={isInteractive ? onClick : undefined}
      onKeyDown={isInteractive ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
      style={{
        borderRadius: 12,
        border: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        cursor: isInteractive ? 'pointer' : 'default',
        userSelect: 'none'
      }}
    >
      {isLoading ? (
        <div>
          <Skeleton.Input active style={{ width: 80, marginBottom: 8 }} />
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </div>
      ) : (
        <>
          <Text style={{ color: '#8c8c8c' }}>{t(labelKey)}</Text>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginTop: 6 }}>
            <Title level={3} style={{ margin: 0, color: accent }}>
              {formatted}
            </Title>
            {unit && <Text type="secondary">/{unit}</Text>}
          </div>
        </>
      )}
    </Card>
  );
};

export default StatWidget;